import Btn from "../../../components/buttons/Btn";
import Chip from "../../../components/basics/Chip";
import { formatDateGetTime } from "../../../utils/formatDate";

import {
  DialogActions,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";

import {
  StyledDialog,
  CustomDialog,
  DialogContentStyled,
  Body,
  Header,
} from "./styles/styles";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@material-ui/lab/";

const ModalLog = ({
  open,
  content,
  setContent,
  setOpen,
  view = "oneclick",
}) => {
  const handleClose = () => {
    setContent(null);
    setOpen(false);
  };

  return (
    <CustomDialog
      maxWidth="md"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      fullWidth={true}
    >
      <StyledDialog>
        <DialogTitle id="dialog-title">
          <Header>
            <Grid container align="center" justifyContent="center">
              <Chip
                bgcolor="primary"
                textcolor="white"
                label="REGISTROS DE ALTERAÇÕES"
              />
            </Grid>
          </Header>
        </DialogTitle>
        <DialogContentStyled>
          <Body>
            <Grid container>
              <Grid item container xs>
                <Timeline align="alternate">
                  {content.map((value, index) => (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent>
                        <Typography color="textSecondary">
                          {formatDateGetTime({
                            date: value.created_at || value.datahora,
                            separator: "/",
                            format: "dd/mm/yyyy/hh:mm:ss",
                          })}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot />
                        {content.length !== index + 1 && <TimelineConnector />}
                      </TimelineSeparator>
                      <TimelineContent>
                        <Typography>
                          {returnItemText({ view, value })}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
                </Timeline>
              </Grid>
            </Grid>
          </Body>
        </DialogContentStyled>
        <DialogActions>
          <Btn
            onClick={handleClose}
            bgcolor="grey"
            label="Fechar"
            hovercolor="blue"
          />
        </DialogActions>
      </StyledDialog>
    </CustomDialog>
  );
};

const returnItemText = ({ view, value }) => {
  const user = value?.usuario?.nome ? `- Usuário: ${value?.usuario?.nome}` : "";
  const views = {
    oneclick:
      value.status === "falha"
        ? `${value.mensagem}, ${value.erro}`
        : value.mensagem,
    contracts: value.descricao ? `${value.descricao} ${user}` : "",
  };

  return views[view] || console.error("Nenhuma View válida especificada.");
};

export { ModalLog };
